<template>
  <div class="basket">
    <div class="row order-header">
      <div class="col-12">Twoje zamówienie</div>
    </div>
    <div v-for="b in basket.basket.baskets" class="order-header-basket order-group">
      <div class="row order-header-address">
        <div class="col-12">
          Adres dostawy:
          <div
            v-if="b.address"
            class="basket-group-delivery"
          >{{ b.address.city }}, {{ b.address.street }}</div>
        </div>
      </div>
      <table class="table order-header-cols">
        <thead>
          <tr>
            <th scope="col">zdjęcie</th>
            <th scope="col">nazwa</th>
            <th scope="col">mpk</th>
            <th scope="col">ilość</th>
            <th scope="col">netto</th>
            <th scope="col">vat</th>
            <th scope="col">brutto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="position in b.positions" class="order-position">
            <td>
              <img :src="position.photo_url" class="img-fluid order-img" />
            </td>
            <td class="order-product-name">
              <span class="order-name-name">{{position.name}}</span>
              <span class="order-name-desc">{{position.description}}</span>
              <div v-if="position.range" class="basket-gratis-info my-1">
                <div
                  v-if="position.cart_quantity < position.range.min_quantity"
                  class="alert alert-info mb-0"
                >
                  <img
                    src="./../../../assets/icons/info.svg"
                    alt="Info Icon"
                    class="basket-gratis-info-icon mr-1"
                    style="width: 1.5rem;"
                  />
                  Kup jeszcze {{quantityToGratis(position.range.min_quantity, position.cart_quantity)}}
                  <!-- <span>{{quantityToGratisLabel(position.range.min_quantity, position.cart_quantity)}}</span> -->
                  <span
                    v-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) === 1"
                  >sztukę</span>
                  <span
                    v-else-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) >= 2 && quantityToGratis(position.range.min_quantity, position.cart_quantity) <= 4"
                  >sztuki</span>
                  <span v-else>sztuk</span>
                  tego produktu, a otrzymasz
                  <span
                    class="basket-gratis-product"
                  >{{ position.range.product_name }}</span>
                </div>
                <div v-else class="alert alert-success mb-0 text-left" style="color: #155724;">
                  <img
                    src="./../../../assets/icons/info.svg"
                    alt="Info Icon"
                    class="basket-gratis-info-icon mr-1"
                    style="width: 1.5rem;"
                  />
                  Otrzymujesz gratis
                  <span
                    class="basket-gratis-product"
                  >{{ position.range.product_name }}!</span>
                </div>
              </div>
            </td>
            <td>-</td>
            <td>{{position.cart_quantity}}</td>
            <td>{{formatPrice(position.price_net * position.cart_quantity)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(position.price_tax * position.cart_quantity)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(position.price_gross * position.cart_quantity)}} {{currency().currency.symbol}}</td>
          </tr>

          <tr class="order-footer">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{formatPrice(b.price_net)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(b.price_tax)}} {{currency().currency.symbol}}</td>
            <td>{{formatPrice(b.price_gross)}} {{currency().currency.symbol}}</td>
          </tr>
        </tbody>
      </table>

      <div class="row order-header">
        <div class="col-12">
          <button
            type="button"
            class="btn btn-success pull-right"
            @click="createOrder()"
          >Złóż zamówienie</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import SubIcon from "vue-material-design-icons/Minus.vue";
import PlusIcon from "vue-material-design-icons/Plus.vue";
import { mapState, mapGetters } from "vuex";
import MinusIcon from "vue-material-design-icons/Minus.vue";

export default {
  computed: {
    ...mapState({
      basket: state => state.basket,
      order: state => state.order
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },

  methods: {
    formatPrice(value) {
      let currValue = value * this.currency().value;

      let val = (currValue / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    quantityToGratis(range, basket) {
      return range - basket;
    },

    async createOrder() {
      await this.$store.dispatch("order/create");
      this.$router.replace({ name: "orders" });
    }
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }

    this.$store.dispatch("basket/data");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/order/src/CreateOrderPage.vue